import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-sop-cl',
  templateUrl: './sop-cl.component.html',
  styleUrls: ['./sop-cl.component.css']
})
export class SopClComponent implements OnInit {
    sopKeyno;

    sopClKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.sopKeyno = this.stateService.getStateParams()['sop_keyno'];
        this.sopClKeyno = this.stateService.getStateParams()['sopcl_keyno'];
    }

    private async loadEdit() {
        if (!!this.sopKeyno && !!this.sopClKeyno) {
            this.edit = (await this.datatask.Post(1849, {
                sop_keyno: this.sopKeyno,
                sopcl_keyno: this.sopClKeyno
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1850, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    sop_keyno: string;
    sop_name: string;
    sopcl_keyno: string;
    sopcl_name: string;
    orderby: string;
    isactive: string;
}
